import React from "react";
import CopyToClipboard from "react-copy-to-clipboard";
import { alertSuccess } from "@/utils/alerts";
import { t } from "i18next";
import cx from "classnames";
import { Icon, copy } from "../../icons";

const InnerButton = ({ className, disabled = false }) => (
  <div
    className={cx(
      "border rounded border-qb-border-gray cursor-pointer flex justify-center items-center py-2 px-3 gap-1  hover:bg-qb-bg text-sm",
      className,
      disabled ? "pointer-events-none text-qb-text-a40" : "text-qb-text-a60"
    )}
  >
    {t("action.copy")}
    <Icon className={disabled ? "copy-icon-disabled" : null} svg={copy} width="0.75rem" />
  </div>
);
const ButtonCopy = ({ value, className, disabled }) => (
  <>
    {!disabled ? (
      <CopyToClipboard text={value} onCopy={() => alertSuccess(t("alert.successfullyCopied"))}>
        <div>
          <InnerButton className={className} />
        </div>
      </CopyToClipboard>
    ) : (
      <InnerButton className={className} disabled />
    )}
  </>
);

export default ButtonCopy;
